import { LearnersState } from '@pages/report-card/store/states/learners.state';
import { CoursesState } from '@pages/report-card/store/states/courses.state';
import { MyCoursesState } from '@pages/report-card/store/states/my-courses.state';

export const reportCardPageState = [LearnersState, CoursesState, MyCoursesState];
